import React, { useState, useRef, lazy, Suspense } from "react";
import LoadingSpinner from "./components/LoadingSpinner.tsx";
import { CountProvider } from "../../../src/context/CountContext.tsx";
import { useUserContext } from "../../../src/context/UserContext.tsx";

// Code-split all heavy sections
const ReportCountSummary = lazy(() => import("./ReportCountSummary.tsx"));
const ReportSummaryCard  = lazy(() => import("./components/ReportSummaryCard.tsx"));
const CustomReports      = lazy(() => import("./CustomReports.tsx"));
const ReportDetailsSection = lazy(() => import("./ReportDetailsSection.tsx"));

const ReportSummaryPage: React.FC = () => {
  const [tempLoad, setTempLoad]     = useState(false);
  const [reportsData, setReportsData] = useState<any[]>([]);
  const reportDetailsRef            = useRef<HTMLDivElement>(null);
  const { globalstorevalue }        = useUserContext();
 
  return (
    <div className="flex flex-col gap-6 px-1">
 
      {/* ── KPI Counts ── */}
      <Suspense fallback={<LoadingSpinner />}>
        <CountProvider>
          <ReportCountSummary storeValue={globalstorevalue || ""} />
        </CountProvider>
      </Suspense>
 
      {/* ── Yearly / Monthly / Weekly tab card ── */}
      <Suspense fallback={<LoadingSpinner />}>
        <ReportSummaryCard
          storeValue={globalstorevalue || ""}
          setReportsData={setReportsData}
          setTempLoad={setTempLoad}
          reportDetailsRef={reportDetailsRef}
        />
      </Suspense>
 
      {/* ── Custom date range summary ── */}
      <Suspense fallback={<LoadingSpinner />}>
        <CustomReports
          storeValue={globalstorevalue || ""}
          setReportsData={setReportsData}
          tempLoad={tempLoad}
          setTempLoad={setTempLoad}
          reportDetailsRef={reportDetailsRef}
        />
      </Suspense>
 
      {/* ── Drill-down report details ── */}
      <div ref={reportDetailsRef}>
        <Suspense fallback={<LoadingSpinner />}>
          <ReportDetailsSection
            ReportsData={reportsData}
            setReportsData={setReportsData}
            tempLoad={tempLoad}
            setTempLoad={setTempLoad}
          />
        </Suspense>
      </div>
 
    </div>
  );
};
 
export default ReportSummaryPage;
 